import Vue from 'vue';
import Vuex from 'vuex';
import {Player} from '@/models/Player';


Vue.use(Vuex);

interface PlayerState {
	players: Player[];
}

/**
 * Store in indexDb an user
 */
class PlayerStore {
	
	
	public state: PlayerState = {
		players: [ new Player(), new Player() ],
	};
	
	public mutations = {
		
		addPlayer(state: PlayerState, player: Player) {
			state.players.push(player);
		},
		
		removePlayer(state: PlayerState, player: Player) {
			state.players = state.players.filter(p => p.id != player.id);
		},
		
		setPlayers(state: PlayerState, players: Player[]) {
			state.players = players;
		},
		
		reset(state: PlayerState) {
			state.players = [ new Player(), new Player() ];
		}
		
	};
	
	public actions = {
	
	};
	
}
const playerStore = new PlayerStore();

export default new Vuex.Store(playerStore);
